import { NgModule } from '@angular/core';
import { ServicosComponent } from './servicos.component';
import { Routes, RouterModule } from '@angular/router';
import { RoleGuard } from 'src/app/shared/guards/role.guard';
import { ServiceFormComponent } from './service-form/service-form.component';

const routes:Routes=[
  {path:'',redirectTo:'list',pathMatch:'full'},
  {path:'list',component:ServicosComponent,canActivate:[RoleGuard],data:{roles: ["user", "admin"]}},
  {path:'new',component:ServiceFormComponent,canActivate:[RoleGuard],data:{roles: ["admin"]}},
  {path:'edit',component:ServiceFormComponent,canActivate:[RoleGuard],data:{roles: ["admin"]}},
]
  // o Administrador Khuzela faz CRUD
  // o Utilizador Khuzela  só Lê
  // o Manager do Clube só Lê
  // o Utilizador do Clube só Lê

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports:[
    RouterModule
  ]
})
export class ServicosRoutingModule { }
